// extracted by mini-css-extract-plugin
module.exports = {"privacyBox":"privacyStyles_privacyBox__qBEn7"};